// extracted by mini-css-extract-plugin
module.exports = {"comm":"comm_comm__3CJ2M"};